<template>
    <Datepicker class="part_ui_date_picker"
                v-model="date"
                :disabled="disabled"
                :language="lang"
                :monday-first="true"
                :disabledDates="{
                    to: minDate,
                    from: maxDate
                }"
                :input-class="'datepicker-input'"
                :calendar-class="'datepicker-calendar'"
                :format="'dd.MM.yyyy'"
                :clear-button="clearButton"
                clear-button-icon="icon icon--close"
                :placeholder="placeholder"/>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import {cs, en, sk} from 'vuejs-datepicker/dist/locale'

export default {
    name: 'DateInput',
    props: {
        value: Date,
        placeholder: String,
        clearButton: Boolean,
        minDate: Date,
        maxDate: Date,
        disabled: Boolean
    },
    components: {
        Datepicker
    },
    computed: {
        date: {
            get() {
                return this.value
            },
            set(value) {
                this.$emit('input', value)
            },
        },
        lang: {
            get() {
                const locale = this.$i18n.locale
                switch (locale) {
                    case 'cs':
                        return cs
                    case 'en':
                        return en
                    case 'sk':
                        return sk
                    default:
                        console.error('Unknown datepicker locale for language ' + locale)
                        return en
                }
            }
        }
    },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/templates/part/item/date_input.vue